import api from "@/api/api";
import { ApiPharmacy } from "./";
const PharmacyService = {
  async getPharmacyList(){
    return await api.get(ApiPharmacy.GET_PHARMACIES);
  }
}

export default PharmacyService;